<template>
<div >
	<Loader :show="loading"></Loader>
	<b-modal id="modalUser" :title="title" hide-footer no-close-on-backdrop no-close-on-esc @close="close">
		<UserForm :id="id" @loaded="loading=false" @updated="close()" ></UserForm>
	</b-modal>	
</div>
</template>

<script>
import UserForm from '@/views/users/UserForm'
import Loader from '@/components/Loader'

export default {
	name: 'UserModal',
	components:{
		UserForm,
		Loader
	},
	data () {
		return {
			title: 'Crear usuario',
			show: false,
			loading:false,
			id: null
		}
	},
	methods: {
		open (id=null) {
			this.id = id
			if( id!==null ){
				this.title = 'Editar usuario'
			}else{	
				this.title = 'Crear usuario'
			}
				this.loading = true
			this.showModal()
		},
		showModal() {
			this.show = true
			this.$bvModal.show('modalUser')
		},
		close () {
			this.show = false
			this.form = {}
			this.$emit('updated')
			this.$bvModal.hide('modalUser')
		},
	}
}


</script>
